import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Input } from "../components/input";
import { createCampaign, getCampaign } from "../services/axios";
import { toast } from "sonner";

export const Landing = () => {
  const [campaign, setCampaign] = useState("");
  let history = useHistory();

  const create = async () => {
    if (campaign) {
      let result = await createCampaign({ id: campaign });
      if (!result) {
        toast.error("error");
      }
      toast.success("saved");
      history.push({
        pathname: `/campaign/${campaign}`,
      });
    }
  };

  async function handleCreateOrGoTo() {
    const check = await getCampaign(campaign);
    if (!check) {
      return create();
    } else {
      return history.push({
        pathname: `/campaign/${campaign}`,
      });
    }
  }

  return (
    <div className="bg-white">
      <div className="flex justify-center items-center m-8">
        <div className="w-full flex flex-col space-y-4">
          <div className="p-2 font-bold text-2xl">Campaigns</div>
          <div className="w-max-7xl gap-4">
            <div className="border p-8">
              <div className="flex flex-col space-y-4">
                <Input
                  label="create or go to campaign"
                  placeholder="ex: 12345"
                  field="campaign"
                  value={campaign}
                  onChange={(field: string, e: any) => {
                    setCampaign(e.target.value);
                  }}
                />
                <button
                  onClick={() => handleCreateOrGoTo()}
                  className="bg-black px-4 py-2 text-white my-4"
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
